import ApiHttpHandler from "./apiHttpHandler";
const handler = new ApiHttpHandler();
const getCustomer = (id) => {
    return handler.get(`customers/${id}`);
};
const getCustomers = (page, pageSize) => {
    return handler.get(`customers?page=${page}&pageSize=${pageSize}`);
};
const addCustomer = (model) => {
    return handler.post("customers", model);
};
const deleteCustomer = (id) => {
    return handler.delete(`customers/${id}`);
};
const findCustomerByDroneId = (droneId, page, pageSize) => {
    return handler.get(`customers/find?query=${droneId}&page=${page}&pageSize=${pageSize}`);
};
export default {
    getCustomers,
    getCustomer,
    addCustomer,
    deleteCustomer,
    findCustomerByDroneId,
};
